import { flow, types } from 'mobx-state-tree'
import { Screens } from '../../nav/Screens'
import { getBankList } from '../../network/getBankList'
import { JIO_PAYMENT_BANK_BIN } from '../../util/utill'
import { RootStore } from '../store'

const KEYS = {
  CUSTOMER_CW: 'CW',
  CUSTOMER_CD: 'CD',
  CUSTOMER_BI: 'BI',
  CUSTOMER_FT: 'FT',
  CUSTOMER_MS: 'MS',
}

const Bank = types.model('Bank', {
  bankName: types.optional(types.string, ''),
  bankBin: types.optional(types.string, ''),
  bankId: types.optional(types.string, ''),
  highValueTxnAmt: types.optional(types.number, 0),
})

const Banks = types
  .model('Banks', {
    CD: types.array(Bank),
    CW: types.array(Bank),
    FT: types.array(Bank),
    BI: types.array(Bank),
    MS: types.array(Bank),
  })
  .actions((self) => ({
    getBankListApi: flow(function* getBankListApi() {
      console.log('aeps timing firing banks : ', new Date().toISOString())
      const res = yield getBankList(RootStore?.agent?.session).catch((err: any) => {
        RootStore.message.handleError(err)
        throw err
      })
      self.CD = res.CD
      self.CW = res.CW
      self.FT = res.FT
      self.BI = res.BI
      self.MS = res.MS
      return res
    }),
  }))

  .views((self) => ({
    getBankList: (
      screenName: string,
      activityType: 'CUSTOMER_CW' | 'CUSTOMER_CD' | 'CUSTOMER_BI' | 'CUSTOMER_FT' | 'CUSTOMER_MS',
    ) => {
      const key: 'CD' | 'CW' | 'FT' | 'BI' | 'MS' = KEYS[activityType] as any
      const banks = self?.[key].map((item: any) => ({ text: item.bankName, bankBin: item.bankBin }))
      if (screenName === Screens.CASH_W_OR_D_Screen) {
        banks.sort((x, y) => {
          return x.bankBin === JIO_PAYMENT_BANK_BIN ? -1 : y.bankBin === JIO_PAYMENT_BANK_BIN ? 1 : 0
        })
      }
      return banks
    },
    getBankId: (
      bankName: string,
      activityType: 'CUSTOMER_CW' | 'CUSTOMER_CD' | 'CUSTOMER_BI' | 'CUSTOMER_FT' | 'CUSTOMER_MS',
    ) => {
      const key: 'CD' | 'CW' | 'FT' | 'BI' | 'MS' = KEYS[activityType] as any
      return self?.[key]?.filter((bank) => bank.bankName === bankName)[0].bankBin
    },
    getHighValueAmount: (
      bankName: string,
      activityType: 'CUSTOMER_CW' | 'CUSTOMER_CD' | 'CUSTOMER_BI' | 'CUSTOMER_FT' | 'CUSTOMER_MS',
    ) => {
      if (activityType === 'CUSTOMER_CW') {
        const key = KEYS[activityType] as 'CW'
        const selectedBank = self?.[key]?.find((bank: any) => bank.bankName === bankName)
        return selectedBank?.highValueTxnAmt || 0
      }
      return 0
    },
  }))

const BanksData = Banks.create({ CD: [], CW: [], FT: [], BI: [], MS: [] })

export { Banks, BanksData }
